import React, { Component } from 'react'
import './index.scss'
import { Carousel } from 'antd'

class index extends Component {
  state = {
    carousel: React.createRef(),
    num: 1
  }

  render() {
    return (
      <div style={{ position: 'relative', width: '100%' }}>
        <Carousel autoplay dots={false} ref={this.state.carousel} afterChange={(e) => this.setState({ num: e + 1 })}>
        {/* <img src={require('../../image/Banner-04.jpg')} style={{ height: '22.85714rem', width: '100%' }}></img> */}
          <img src={require('../../image/Banner-01.jpg')} style={{ height: '22.85714rem', width: '100%' }}></img>
          <img src={require('../../image/Banner-02.jpg')} style={{ height: '22.85714rem', width: '100%' }}></img>
          <img src={require('../../image/Banner-03.jpg')} style={{ height: '22.85714rem', width: '100%' }}></img>
        </Carousel>
        <div className=" goout">
          <div className="goout-content">
            <div className="goout-hint">
              <img src={require('../../image/icon鼠标.png')} className="goout-hint-icon"></img>
              <span>向下滑动</span>
            </div>
            <div className="goout-operation">
              <img className="goout-operation-icon" onClick={() => this.state.carousel.current.prev()} src={require('../../image/left.png')} alt="" />
              <span className="goout-operation-span">{this.state.num}/3</span>
              <img className="goout-operation-icon" onClick={() => this.state.carousel.current.next()} src={require('../../image/right.png')} alt="" />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default index
